import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VoucherConditionModal from "./VoucherConditionModal";

export default function MyVoucherSection() {
    const [openVoucher, setOpenVoucher] = useState(false);
    const navigate = useNavigate();
    const [time, setTime] = useState({
        days: 22,
        hours: 8,
        minutes: 42,
        seconds: 14,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(prev => {
                let { days, hours, minutes, seconds } = prev;

                if (seconds > 0) {
                    seconds--;
                } else {
                    seconds = 59;
                    if (minutes > 0) {
                        minutes--;
                    } else {
                        minutes = 59;
                        if (hours > 0) {
                            hours--;
                        } else {
                            hours = 23;
                            if (days > 0) {
                                days--;
                            } else {
                                clearInterval(timer);
                            }
                        }
                    }
                }

                return { days, hours, minutes, seconds };
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="MuiContainer-root styles_container__3w0uC MuiContainer-maxWidthLg">
            <div id="sectionMyVoucher" style={{ scrollMarginTop: "115px" }}>
                <div className="MuiBox-root css-yd8sa2">
                    {/* ===== GRID LIST ===== */}
                    <div className="MuiGrid-root MuiGrid-container">
                        {/* ================== ITEM 1 ================== */}
                        <div
                            className="MuiGrid-root w-50-desktop MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-"
                            style={{ position: "relative", borderRadius: 12, overflow: "hidden" }}
                        >
                            <div
                                className="styles_voucherRightMissingPart__ghZZb styles_voucherRightMissingPartWithMessage__O2NeA"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />
                            <div
                                className="styles_voucherLeftMissingPart__Dd9yV styles_voucherLeftMissingPartWithMessage__1TuQu"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />

                            <div
                                className="MuiBox-root css-0"
                                style={{
                                    position: "relative",
                                    borderRadius: 12,
                                    border: "1px solid rgb(235, 235, 235)",
                                }}
                            >
                                <div className="MuiGrid-root" style={{ position: "relative", overflow: "hidden" }}>
                                    <div className="MuiGrid-root styles_voucherItem_wrapper__6dbHT">
                                        <div className="MuiGrid-root styles_voucherContainer_upper__P4pdw MuiGrid-container">
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9 MuiGrid-grid-md-9">
                                                <p className="MuiTypography-root styles_voucherContent_title__W0Q3Z MuiTypography-body2 MuiTypography-noWrap">
                                                    GIẢM 3.92%
                                                </p>
                                                <p className="MuiTypography-root MuiTypography-body2">
                                                    <div className="styles_voucherContent_desc__ANOqH styles_content_2Line__BrNP1">
                                                        Giảm tối đa 20K cho sản phẩm Hapacol 250mg dhg (H/24g/1.5gr)
                                                    </div>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="styles_voucherDivider__7rclz" />

                                        <div className="MuiGrid-root styles_voucherContainer_downer__DSU6c">
                                            <div className="MuiGrid-root MuiGrid-container">
                                                <div className="MuiGrid-root styles_expiredDateBarWrapper__ffAl6 MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-md-5">
                                                    <p
                                                        className="MuiTypography-root MuiTypography-body2"
                                                        style={{
                                                            lineHeight: "14px",
                                                            color: "rgb(0, 0, 0)",
                                                            fontFamily: "ggsm",
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        <span style={{ color: "rgb(212, 50, 59)" }}>
                                                            Còn{" "}
                                                            <div style={{ display: "inline-block" }}>
                                                                <span>{time.days} ngày, </span>
                                                                <span>{String(time.hours).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.minutes).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.seconds).padStart(2, "0")}</span>
                                                            </div>
                                                        </span>
                                                    </p>
                                                </div>

                                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7">
                                                    <div
                                                        className="MuiGrid-root"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: 8,
                                                        }}
                                                    >
                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text"
                                                            tabIndex={0}
                                                            type="button"
                                                            style={{
                                                                color: "rgb(14, 25, 131)",
                                                                padding: "6px 8px",
                                                                textTransform: "unset",
                                                            }}
                                                        >
                                                            <span className="MuiButton-label">
                                                                <svg
                                                                    className="MuiSvgIcon-root"
                                                                    focusable="false"
                                                                    viewBox="0 0 24 24"
                                                                    aria-hidden="true"
                                                                    style={{ width: 20, height: 20 }}
                                                                >
                                                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                </svg>
                                                                <p
                                                                    className="MuiTypography-root MuiTypography-body2"
                                                                    style={{ paddingLeft: 8, fontSize: 12, lineHeight: "18px" }}
                                                                    onClick={() => setOpenVoucher(true)}
                                                                >
                                                                    Điều kiện
                                                                </p>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>

                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_voucherCondition_btnUsing__x1T_J styles_voucherCondition_btn__UY8KH"
                                                            tabIndex={0}
                                                            type="button"
                                                        >
                                                            <span className="MuiButton-label">
                                                                <span>Đang sử dụng</span>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="MuiGrid-root styles_errorMessage_buyMoreContainer__a0rSG">
                                    <p className="MuiTypography-root MuiTypography-body2">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "100%",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "16px",
                                            }}
                                        >
                                            <img className="!w-4 !h-4" alt="error icon" data-origin-url="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" decoding="async" data-nimg="intrinsic"
                                            />
                                        </span>

                                        Mua thêm sản phẩm theo điều kiện
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ================== ITEM 2 ================== */}
                        <div
                            className="MuiGrid-root w-50-desktop MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-"
                            style={{ position: "relative", borderRadius: 12, overflow: "hidden" }}
                        >
                            <div
                                className="styles_voucherRightMissingPart__ghZZb styles_voucherRightMissingPartWithMessage__O2NeA"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />
                            <div
                                className="styles_voucherLeftMissingPart__Dd9yV styles_voucherLeftMissingPartWithMessage__1TuQu"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />

                            <div
                                className="MuiBox-root css-0"
                                style={{
                                    position: "relative",
                                    borderRadius: 12,
                                    border: "1px solid rgb(235, 235, 235)",
                                }}
                            >
                                <div className="MuiGrid-root" style={{ position: "relative", overflow: "hidden" }}>
                                    <div className="MuiGrid-root styles_voucherItem_wrapper__6dbHT">
                                        <div className="MuiGrid-root styles_voucherContainer_upper__P4pdw MuiGrid-container">
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9 MuiGrid-grid-md-9">
                                                <p className="MuiTypography-root styles_voucherContent_title__W0Q3Z MuiTypography-body2 MuiTypography-noWrap">
                                                    GIẢM 9.15%
                                                </p>
                                                <p className="MuiTypography-root MuiTypography-body2">
                                                    <div className="styles_voucherContent_desc__ANOqH styles_content_2Line__BrNP1">
                                                        Giảm tối đa 20K cho sản phẩm Hapacol 250mg dhg (H/24g/1.5gr)
                                                    </div>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="styles_voucherDivider__7rclz" />

                                        <div className="MuiGrid-root styles_voucherContainer_downer__DSU6c">
                                            <div className="MuiGrid-root MuiGrid-container">
                                                <div className="MuiGrid-root styles_expiredDateBarWrapper__ffAl6 MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-md-5">
                                                    <p
                                                        className="MuiTypography-root MuiTypography-body2"
                                                        style={{
                                                            lineHeight: "14px",
                                                            color: "rgb(0, 0, 0)",
                                                            fontFamily: "ggsm",
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        <span style={{ color: "rgb(212, 50, 59)" }}>
                                                            Còn{" "}
                                                            <div style={{ display: "inline-block" }}>
                                                                <span>{time.days} ngày, </span>
                                                                <span>{String(time.hours).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.minutes).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.seconds).padStart(2, "0")}</span>
                                                            </div>
                                                        </span>
                                                    </p>
                                                </div>

                                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7">
                                                    <div
                                                        className="MuiGrid-root"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: 8,
                                                        }}
                                                    >
                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text"
                                                            tabIndex={0}
                                                            type="button"
                                                            style={{
                                                                color: "rgb(14, 25, 131)",
                                                                padding: "6px 8px",
                                                                textTransform: "unset",
                                                            }}
                                                        >
                                                            <span className="MuiButton-label">
                                                                <svg
                                                                    className="MuiSvgIcon-root"
                                                                    focusable="false"
                                                                    viewBox="0 0 24 24"
                                                                    aria-hidden="true"
                                                                    style={{ width: 20, height: 20 }}
                                                                >
                                                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                </svg>
                                                                <p
                                                                    className="MuiTypography-root MuiTypography-body2"
                                                                    style={{ paddingLeft: 8, fontSize: 12, lineHeight: "18px" }}
                                                                    onClick={() => setOpenVoucher(true)}
                                                                >
                                                                    Điều kiện
                                                                </p>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>

                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_voucherCondition_btnBuyMore__l47_i styles_voucherCondition_btn__UY8KH"
                                                            type="button"
                                                            onClick={() => navigate("/quick-order")}
                                                        >
                                                            <span className="MuiButton-label"><span>Mua thêm</span></span><span className="MuiTouchRipple-root"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="MuiGrid-root styles_errorMessage_buyMoreContainer__a0rSG">
                                    <p className="MuiTypography-root MuiTypography-body2">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "100%",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "16px",
                                            }}
                                        >
                                            <img className="!w-4 !h-4" alt="error icon" data-origin-url="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" decoding="async" data-nimg="intrinsic"
                                            />
                                        </span>

                                        Mua thêm sản phẩm theo điều kiện
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ================== ITEM 3 ================== */}
                        <div
                            className="MuiGrid-root w-50-desktop MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-"
                            style={{ position: "relative", borderRadius: 12, overflow: "hidden" }}
                        >
                            <div
                                className="styles_voucherRightMissingPart__ghZZb styles_voucherRightMissingPartWithMessage__O2NeA"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />
                            <div
                                className="styles_voucherLeftMissingPart__Dd9yV styles_voucherLeftMissingPartWithMessage__1TuQu"
                                style={{ backgroundColor: "rgb(244, 247, 252)" }}
                            />

                            <div
                                className="MuiBox-root css-0"
                                style={{
                                    position: "relative",
                                    borderRadius: 12,
                                    border: "1px solid rgb(235, 235, 235)",
                                }}
                            >
                                <div className="MuiGrid-root" style={{ position: "relative", overflow: "hidden" }}>
                                    <div className="MuiGrid-root styles_voucherItem_wrapper__6dbHT">
                                        <div className="MuiGrid-root styles_voucherContainer_upper__P4pdw MuiGrid-container">
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9 MuiGrid-grid-md-9">
                                                <p className="MuiTypography-root styles_voucherContent_title__W0Q3Z MuiTypography-body2 MuiTypography-noWrap">
                                                    GIẢM 15.92%
                                                </p>
                                                <p className="MuiTypography-root MuiTypography-body2">
                                                    <div className="styles_voucherContent_desc__ANOqH styles_content_2Line__BrNP1">
                                                        Giảm tối đa 20K cho sản phẩm Hapacol 250mg dhg (H/24g/1.5gr)
                                                    </div>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="styles_voucherDivider__7rclz" />

                                        <div className="MuiGrid-root styles_voucherContainer_downer__DSU6c">
                                            <div className="MuiGrid-root MuiGrid-container">
                                                <div className="MuiGrid-root styles_expiredDateBarWrapper__ffAl6 MuiGrid-item MuiGrid-grid-sm-4 MuiGrid-grid-md-5">
                                                    <p
                                                        className="MuiTypography-root MuiTypography-body2"
                                                        style={{
                                                            lineHeight: "14px",
                                                            color: "rgb(0, 0, 0)",
                                                            fontFamily: "ggsm",
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        <span style={{ color: "rgb(212, 50, 59)" }}>
                                                            Còn{" "}
                                                            <div style={{ display: "inline-block" }}>
                                                                <span>{time.days} ngày, </span>
                                                                <span>{String(time.hours).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.minutes).padStart(2, "0")}</span>
                                                                <span>:</span>
                                                                <span>{String(time.seconds).padStart(2, "0")}</span>
                                                            </div>
                                                        </span>
                                                    </p>
                                                </div>

                                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7">
                                                    <div
                                                        className="MuiGrid-root"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            gap: 8,
                                                        }}
                                                    >
                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text"
                                                            tabIndex={0}
                                                            type="button"
                                                            style={{
                                                                color: "rgb(14, 25, 131)",
                                                                padding: "6px 8px",
                                                                textTransform: "unset",
                                                            }}
                                                        >
                                                            <span className="MuiButton-label">
                                                                <svg
                                                                    className="MuiSvgIcon-root"
                                                                    focusable="false"
                                                                    viewBox="0 0 24 24"
                                                                    aria-hidden="true"
                                                                    style={{ width: 20, height: 20 }}
                                                                >
                                                                    <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                                                </svg>
                                                                <p
                                                                    className="MuiTypography-root MuiTypography-body2"
                                                                    style={{ paddingLeft: 8, fontSize: 12, lineHeight: "18px" }}
                                                                    onClick={() => setOpenVoucher(true)}
                                                                >
                                                                    Điều kiện
                                                                </p>
                                                            </span>
                                                            <span className="MuiTouchRipple-root" />
                                                        </button>

                                                        <button
                                                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_voucherCondition_btnBuyMore__l47_i styles_voucherCondition_btn__UY8KH"
                                                            type="button"
                                                            onClick={() => navigate("/quick-order")}
                                                        >
                                                            <span className="MuiButton-label"><span>Mua thêm</span></span><span className="MuiTouchRipple-root"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="MuiGrid-root styles_errorMessage_buyMoreContainer__a0rSG">
                                    <p className="MuiTypography-root MuiTypography-body2">
                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "100%",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "16px",
                                            }}
                                        >
                                            <img className="!w-4 !h-4" alt="error icon" data-origin-url="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/promoCode/error_code_icon.svg" decoding="async" data-nimg="intrinsic"
                                            />
                                        </span>

                                        Mua thêm sản phẩm theo điều kiện
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <VoucherConditionModal
                open={openVoucher}
                onClose={() => setOpenVoucher(false)}
            />
        </div>
    );
}
